import Vue from 'vue';
import Vuex from 'vuex';
import { UserState } from './modules/user';

Vue.use(Vuex);

export interface IRootState {
  user: UserState;
}


// Declare empty store first, dynamiclly register all modules later;
export default new Vuex.Store<IRootState>({});
